import React, { FormEvent, useState } from "react";
import { Navigate, replace, useNavigate } from "react-router-dom";
import { AddTestimonial } from "../../services/others/service";
import toast from "react-hot-toast";
import { Zoom } from "react-awesome-reveal";

const FeedbackForm = () => {
  const navigate = useNavigate();
  const [position, setPosition] = useState("");
  const [message, setMessage] = useState("");
  const [loading, setLoading] = useState(false);
  const [messageSent, setMessageSent] = useState(false);
  const handleSubmit = async (e: FormEvent) => {
    e.preventDefault();
    setLoading(true);
    try {
      const payload = {
        position: position,
        testimonial_description: message,
      };

      const response = await AddTestimonial(payload);
      if (response) {
        setMessageSent(true);
        setPosition("");
        setMessage("");
      }
    } catch (error: any) {
      toast.error(error?.response?.data?.message);
    } finally {
      setLoading(false);
    }
  };

  const handleCancel = () => {
    setPosition("");
    setMessage("");
    window.history.back();
  };

  return (
    <>
      {messageSent ? (
        <SuccessMessage onClose={handleCancel} />
      ) : (
        <div className="bg-[#232627] w-full lg:px-0 px-5 h-screen flex items-center justify-center">
          <Zoom className="w-full">
            <div className="w-full max-w-md mx-auto mt-10 bg-gradient-to-br from-gray-800 to-gray-700 p-6 rounded-lg shadow-lg border border-gray-600">
              <h2 className="text-2xl font-bold text-white text-center">
                We’d Love Your Feedback
              </h2>
              <p className="text-gray-300 text-center mt-2 mb-6">
                Help us improve by sharing your thoughts.
              </p>

              <form onSubmit={handleSubmit} className="space-y-4">
                <div>
                  <label
                    htmlFor="position"
                    className="block text-sm font-medium text-gray-200"
                  >
                    Your Position
                  </label>
                  <select
                    id="position"
                    value={position}
                    onChange={(e) => setPosition(e.target.value)}
                    required
                    className="w-full mt-1 p-2 bg-gray-800 border border-gray-600 text-gray-200 rounded-md shadow-sm focus:outline-none focus:ring-teal-500 focus:border-teal-500"
                  >
                    <option value="" disabled>
                      Select your role
                    </option>
                    <option value="Developer">Developer</option>
                    <option value="Designer">Designer</option>
                    <option value="Manager">Manager</option>
                    <option value="Lawyer">Lawyer</option>
                    <option value="Magistrate">Magistrate</option>
                    <option value="Chief Magistrate">Chief Magistrate</option>
                    <option value="Barister">Barister</option>
                    <option value="Registrar">Registrar</option>
                    <option value="Chief Judge">Chief Judge</option>
                    <option value="Judge">Judge</option>
                    <option value="Other">Other</option>
                  </select>
                </div>

                <div>
                  <label
                    htmlFor="message"
                    className="block text-sm font-medium text-gray-200"
                  >
                    Your Message
                  </label>
                  <textarea
                    id="message"
                    rows={4}
                    placeholder="Share your experience or feedback here..."
                    value={message}
                    onChange={(e) => setMessage(e.target.value)}
                    required
                    className="w-full mt-1 p-2 bg-gray-800 border border-gray-600 text-gray-200 rounded-md shadow-sm focus:outline-none focus:ring-teal-500 focus:border-teal-500"
                  ></textarea>
                </div>

                {/* Buttons */}
                <div className="flex justify-between">
                  {position !== "" && message !== "" && (
                    <button
                      type="submit"
                      className="px-4 py-2 bg-teal-500 text-white font-semibold rounded-md shadow-sm hover:bg-teal-600 transition"
                    >
                      {loading ? "Please wait..." : "Submit"}
                    </button>
                  )}

                  <button
                    type="button"
                    className="px-4 py-2 bg-gray-800 border border-teal-500 text-teal-500 font-semibold rounded-md shadow-sm hover:bg-gray-700 transition"
                    onClick={handleCancel}
                  >
                    Cancel
                  </button>
                </div>
              </form>
            </div>
          </Zoom>
        </div>
      )}
    </>
  );
};

export default FeedbackForm;

export const SuccessMessage = ({ onClose }: { onClose: () => void }) => {
  return (
    <div className="bg-[#232627] w-full lg:px-0 px-5 h-screen flex items-center justify-center">
      <div className="w-full max-w-sm mx-auto mt-10 bg-gradient-to-br from-gray-800 to-gray-700 p-6 rounded-lg shadow-lg text-center border border-gray-600">
        {/* Success Icon */}
        <div className="flex items-center justify-center w-12 h-12 mx-auto bg-teal-500 text-white rounded-full shadow-md">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="h-6 w-6"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M5 13l4 4L19 7"
            />
          </svg>
        </div>

        {/* Success Message */}
        <h3 className="text-xl font-bold text-gray-200 mt-4">Thank You!</h3>
        <p className="text-gray-400 mt-2">
          Your feedback has been submitted successfully.
        </p>

        {/* Close Button */}
        <button
          onClick={onClose}
          className="mt-6 px-4 py-2 bg-gray-800 border border-teal-500 text-teal-500 font-semibold rounded-md shadow-md hover:bg-gray-700 transition"
        >
          Close
        </button>
      </div>
    </div>
  );
};
